module.exports = __webpack_public_path__ + "media/images/fedex-ac7fe64a56310e0d6d76754c3d2d54e4.png";